module.exports = __webpack_public_path__ + "static/one-pitch-at-a-time-4c69756808acf47b1d87eb322be26294.jpg";